import { useEffect, useState } from 'react';
import styled from 'styled-components'
// import home1 from '../assets/home/home1.jpg';


const TitleBox = styled.div`
    overflow: hidden;
`;

const BigImage1 = () => {

    const [load, setLoad] = useState(false);

    useEffect(() => {
        setLoad(true);
    },[]);

  return (
    <Container>
        <TextWrapper>

            <div>
            <TitleBox>
                <Title load={load}>
                    Serviços de Manutenção Residencial e Predial
                </Title>
            </TitleBox>

            <TitleBox>
                <Text load={load}>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur quia quaerat maiores perferendis quas debitis laboriosam rem mollitia distinctio voluptatem illo quibusdam eius, illum, dolore quos placeat impedit possimus dolorem!
                </Text>
            </TitleBox>
            </div>
            <ButtonsWrapper load={load}>
                <Button>Serviços Realizados</Button>
                <ButtonBlack>Entre em Contato</ButtonBlack>
            </ButtonsWrapper>
        </TextWrapper>

        <ImgWrapper load={load} src={"https://cdn.picpng.com/industrail_workers_and_engineers/shape-industrail-workers-and-engineers-33124.png"}>
        </ImgWrapper>
    </Container>
  )
}

const Container = styled.div`
    background-image: linear-gradient(to bottom, #fff,#494544);
    min-height: calc(100vh - 100px);
    width: 100%;
    display: grid;
    grid-template-columns: 1fr;

    @media (min-width: 780px) {
        background-image: linear-gradient(to bottom left, #fff,#494544ba);
        grid-template-columns: 2fr 1fr;
        min-height: calc(100vh - 160px);
    }

    /* background-image: url(${props => props.src});
    background-position: 50% 50%;
    background-repeat: no-repeat;
    background-size: cover; */
`

const TextWrapper = styled.div`
    padding: 0px 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    /* padding: 150px 80px; */

    @media (min-width: 780px) {
       padding: 0px 100px 0 50px;
       margin-top: 0;
       justify-content: center;
    }
`;

const Title = styled.h1`
    color:  #494544;
    font-size:  2rem;
    font-weight: 800;
    margin-bottom: 40px;
    transform: translateY(100%);
    opacity: 0;

    transition: all 1000ms ease-in-out 500ms;
    transform: translateY(${props => props.load ? 0 : "100%"});
    opacity: ${props => props.load ? 1 : 0};

    @media (min-width: 780px) {
       margin-bottom: 20px;
       font-size: 3rem;
       font-weight: 400;
    }
`;

const Text = styled.p`
    color:  #ffffffa7;
    font-size: 1.3rem;
    font-weight: 400;
    line-height: 1.7rem;
    margin-bottom: 40px;
    transform: translateY(100%);
    opacity: 0;

    transition: all 1000ms ease-in-out 1000ms;
    transform: translateY(${props => props.load ? 0 : "100%"});
    opacity: ${props => props.load ? 1 : 0};

    @media (min-width: 780px) {
        font-size: 1.1rem;
        margin-bottom: 20px;
    }
`;

const ButtonsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    text-align: center;
    transition: all 1000ms ease-in-out 1500ms;
    transform: translateY(100%);
    opacity: 0;

    transform: translateY(${props => props.load ? 0 : "100%"});
    opacity: ${props => props.load ? 1 : 0};

    @media (min-width: 780px) {
       flex-direction: row;
       
    }
`;

const Button = styled.div`
    margin-right: 0px;
    background-color:  #f2c70f;
    color: #494544;
    font-size: 1.5rem;
    font-weight: 600;
    padding: 10px 15px;
    cursor: pointer;
    border-radius: 5px;
    transition: color 250ms ease-in;
    margin-bottom: 10px;

    @media (min-width: 780px) {
       margin-right: 15px;
       margin-bottom: 0;
    }
    

    &:hover {
        color: #fff;
    }
`;

const ButtonBlack = styled.div`
    background-color:  #494544;
    color: #f2c70f;
    font-size: 1.5rem;
    font-weight: 600;
    padding: 10px 15px;
    cursor: pointer;
    border-radius: 5px;
    transition: color 250ms ease-in;

    &:hover {
        color: #fff;
    }

    @media (min-width: 780px) {
       
    }
`;

const ImgWrapper = styled.div`
    background-image: url(${props => props.src});
    background-position: 0% 0%;
    background-repeat: no-repeat;
    background-size: cover;
    display: none;

    transition: all 1000ms ease-in-out 500ms;
    opacity: 0;
    opacity: ${props => props.load ? 1 : 0};

    @media (min-width: 780px) {
       display: block;
    }
`;


export default BigImage1